import React from "react"

import { Navigate, Route, Routes } from "react-router-dom"
import IntelligencePage from "./Intelligence"
import TeamsPage from "./teams"
import { PermissionsPage } from "@src/components/zones/Permissions"

import { useZoneContext } from "@src/components/contexts/ZoneContext"
import { ZONE_SETTINGS_SECTIONS } from "@src/utils/zones"
import { ErrorPage } from "@dit/core-frontend"
import { ROUTES } from "@src/constants"

const PAGE = {
  [ZONE_SETTINGS_SECTIONS.INTELLIGENCE]: IntelligencePage,
  [ZONE_SETTINGS_SECTIONS.PERMISSIONS]: PermissionsPage,
  [ZONE_SETTINGS_SECTIONS.TEAMS]: TeamsPage,
}

const SettingsPage = ({ setAdditionalBreadcrumbs }) => {
  const { settingsList, checkZonePermission } = useZoneContext()

  const checkPermissionOrRenderError = (permission, Component) => {
    return checkZonePermission(permission) ? (
      <Component setAdditionalBreadcrumbs={setAdditionalBreadcrumbs} />
    ) : (
      <ErrorPage
        code="403"
        title="Доступ запрещен"
        text="У вас нет прав доступа к этой странице"
        mainLink={ROUTES.HOME}
      />
    )
  }

  return (
    <Routes>
      <Route path="/" element={<Navigate to={settingsList[0].slug} replace />} />
      {settingsList.map(({ slug, permission }) => {
        const PageComponent = PAGE[slug] || <></>
        return (
          <Route
            key={`route-${slug}`}
            path={`/${slug}`}
            element={checkPermissionOrRenderError(permission, PageComponent)}
          />
        )
      })}
      <Route path="*" element={<ErrorPage mainLink={ROUTES.HOME} />} />
    </Routes>
  )
}

export default SettingsPage
